import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MomentModule } from 'ngx-moment';

import { TranslatePipe } from '@recruitee/i18n';
import { DividerComponent, IconComponent } from '@recruitee/user-interface';

import { CreditCardIconPipe } from './credit-card-icon.pipe';

@Component({
  selector: 'rt-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, DividerComponent, TranslatePipe, MomentModule, CreditCardIconPipe],
})
export class CreditCardComponent {
  @Input() public cardType: string;
  @Input() public cardLast4Digits: string;
  @Input() public cardExpirationDate: string;
}
